import { routes } from './routes';
import { About } from './About/About';
import { Pcb } from './PCB/Pcb';
import { ErrorPage } from '@/pages/ErrorPage';

export { routes, Pcb, About, ErrorPage };
